// eslint-disable-next-line clearbit-x/no-tree-shaking-imports
import { fade } from '@material-ui/core/styles/colorManipulator';

const theme = (outerTheme) => ({
  ...outerTheme,

  editorStyles: {
    primary: outerTheme.palette.salesforce[500],
    secondary: outerTheme.palette.salesforce[400],
    tertiary: outerTheme.palette.salesforce[300],
    border: `${fade(outerTheme.palette.salesforce[200], 0.4)}`,
    tint: outerTheme.palette.salesforce[100],
    background: outerTheme.palette.salesforce[0],
    shadow: `0 0 0 1px ${fade(
      outerTheme.palette.salesforce[200],
      0.4,
    )}, 0 1px 2px 1px rgba(0, 0, 0, .08)`,
  },
});

export default theme;
